// ProudlyCaringSeniorsSection.js
import React from 'react';

const ProudlyCaringSeniorsSection = () => {
  return (
    <section className="relative bg-white overflow-hidden">
      {/* Curved section with gradient */}
      <div className="relative" style={{ 
        background: 'linear-gradient(90deg, #AD2647 0%, #E85D2C 100%)',
        clipPath: 'ellipse(150% 100% at 50% 0%)',
        paddingBottom: '120px'
      }}>
        <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 pt-16 pb-8">
          <div className="max-w-3xl">
            <p className="text-white text-sm font-light tracking-wider mb-3 uppercase">
              ALLAWAH HOME CARE
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
              Proudly Caring for Coolamon's Seniors — One Home at a Time
            </h2>
            <p className="text-white text-sm md:text-base font-light leading-relaxed">
              At Allawah Compassionate Home Care, we believe every senior deserves to feel valued, respected, and supported in the place they call home. Our caregivers provide personalised care that promotes safety, independence, and companionship—helping families across Coolamon and beyond find peace of mind and loved ones live life to the fullest.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProudlyCaringSeniorsSection;
